import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["getItemProps", "renderItem", "isHighlighted", "item", "index", "itemAsString", "selectedItemsAsString", "isSelected", "isNavigation", "isGroupItem"];
import React, { memo, useContext } from 'react';
import { DropdownContext } from "../../form/select/dropdown/DropdownContext";
import { Row, View } from "../../layout";
import { GROUP_ITEM_PADDING } from "./constants";
import { StyledDropdownLi } from "./helperComponents";
import { jsx as ___EmotionJSX } from "@emotion/core";

var DropdownLi = function DropdownLi(_ref) {
  var getItemProps = _ref.getItemProps,
      renderItem = _ref.renderItem,
      isHighlighted = _ref.isHighlighted,
      item = _ref.item,
      index = _ref.index,
      itemAsString = _ref.itemAsString,
      selectedItemsAsString = _ref.selectedItemsAsString,
      isSelected = _ref.isSelected,
      isNavigation = _ref.isNavigation,
      isGroupItem = _ref.isGroupItem,
      htmlProps = _objectWithoutProperties(_ref, _excluded);

  var _useContext = useContext(DropdownContext),
      isSearchable = _useContext.isSearchable,
      withCustomSelectionOptions = _useContext.withCustomSelectionOptions;

  var renderDefaultGroupItem = function renderDefaultGroupItem() {
    return ___EmotionJSX(Row, {
      alignItems: "center"
    }, ___EmotionJSX(View, {
      padding: {
        left: GROUP_ITEM_PADDING
      }
    }, item));
  };

  var renderedItem;

  if (!!renderItem) {
    renderedItem = renderItem(item, {
      isHovered: isHighlighted
    });
  } else if (isGroupItem) {
    renderedItem = renderDefaultGroupItem();
  } else {
    renderedItem = item;
  } // Override default Downshift behavior which is aria-selected on hover
  // Use aria-selected to mark selected items in multi-select
  // Don't use aria-selected at all in single select because of inconsistent behavior in Screen Readers


  var selectedItemProps = selectedItemsAsString ? {
    'aria-selected': selectedItemsAsString.includes(itemAsString)
  } : {
    'aria-selected': undefined
  };
  return ___EmotionJSX(StyledDropdownLi, _extends({
    isHighlighted: isHighlighted,
    isSearchable: isSearchable,
    isSelectedNavigation: isSelected && isNavigation,
    withCustomSelectionOptions: withCustomSelectionOptions,
    isGroupItem: isGroupItem
  }, !!getItemProps ? getItemProps({
    item: item,
    index: index
  }) : {}, selectedItemProps, htmlProps), renderedItem);
};

DropdownLi.displayName = 'DropdownLi';
export default /*#__PURE__*/memo(DropdownLi);